import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PasswordValidation, UserService} from '../../../services/user.service';
import {UserType} from '../../../services/CONST';
import {Router} from '@angular/router';
import {EnvService} from '../../../services/env.service';

@Component({
    selector: 'register-form',
    templateUrl: './register-form.component.html',
    styleUrls: ['./register-form.component.scss']
})
export class RegisterFormComponent implements OnInit {
    registerForm: FormGroup;
    showNewPass = false;
    showConfPass = false;

    captcha_key = '';
    recaptcha: any;

    constructor(private fb: FormBuilder, public user: UserService,
                private router: Router, private env: EnvService) {
        this.captcha_key = this.env.captcha_key;
    }

    ngOnInit() {
        this.registerForm = this.fb.group({
            pseudo: '',
            full_name: '',
            email: '',
            password: '',
            confirmPassword: ''
        }, {
            validator: PasswordValidation.MatchPassword // your validation method
        });
    }

    submiData() {
        const form = {...this.registerForm.value};
        delete form.confirmPassword;

        form.type = UserType.CLIENT;

        this.user.addPartnerRegistration(this, form);

    }

    onSuccess() {
        this.router.navigate(['/']);
    }

    resolvedCaptcha($event: string) {
        console.log('recaptcha event', $event);
    }
}
